@if (files().length > 0) {
  <div class="flex gap-1 items-center">
    @if (!isMobile()) {
      <span class="text-proffeo-muted text-sm">{{ 'task-details-modal-added-files' | translate }}:</span>
    }
    <proffeo-thumbnails-carousel
      (thumbnailClick)="onThumbnailClick($event)"
      [files]="files()"
      [allowDelete]="false"
    ></proffeo-thumbnails-carousel>
  </div>
} @else {
  <div class="flex gap-1 items-center">
    <span class="text-proffeo-muted text-sm">{{ 'file-added-activity-file-removed' | translate }}</span>
  </div>
}
